<template>
  <div class="mb-10">
    <div class="d-flex flex-row justify-center">
      <div :class="panelCSS" class="formPanel">
        <v-card
          class="mt-2 mb-4 pa-4"
          color="#b8e2ff"
          bordered
          border-color="#000"
          flat
          :loading="loading"
        >
          <div
            class="d-flex flex-row flex-wrap justify-space-between align-center"
          >
            <div>
              <div class="text-h5">{{ pageTitle }}</div>
              <div class="caption py-1" v-if="data && data.slug">
                /{{ data.slug }}

                <span v-if="data && data.slug && data.slug != ''"
                  ><v-btn icon x-small @click="editSlugPrompt()"
                    ><v-icon x-small color="primary">mdi-pencil</v-icon></v-btn
                  ></span
                >
              </div>
            </div>
            <div>
              <v-btn depressed @click="exitPage()" class="mx-2" text>
                Cancel</v-btn
              ><v-btn
                :disabled="!valid"
                depressed
                color="primary"
                class="mx-2"
                @click="doSave()"
                text
              >
                Save</v-btn
              >
            </div>
          </div>

          <div
            class="caption d-flex flex-row flex-wrap align-center"
            v-if="data"
          >
            <div class="mx-3" v-if="!newItem">id: {{ data.id }}</div>
            <div class="mx-3" v-if="data.added">Added: {{ data.added }}</div>
            <div class="mx-3" v-if="data.updated">
              Updated: {{ data.updated }}
            </div>
            <v-checkbox
              class="mx-3 my-0 py-0"
              v-model="data.display"
              dense
              :hide-details="true"
              label="Publish"
            ></v-checkbox>
            <v-checkbox
              class="mx-3 my-0 py-0"
              v-model="data.discontinued"
              dense
              :hide-details="true"
              label="Discontinued"
            ></v-checkbox>
          </div>
        </v-card>
        <v-alert type="warning" v-if="error">{{ error }}</v-alert>

        <v-form v-model="valid" v-if="data" class="mb-2" lazy-validation>
          <v-text-field
            label="Name"
            v-model="data.name"
            outlined
            class="mr-4"
            @change="nameChange()"
            :rules="nameRules"
            required
            ref="nameField"
          ></v-text-field>
          <v-textarea
            rows="2"
            label="Aliases"
            v-model="data.aliases"
            outlined
            class="mr-4"
            clearable
          ></v-textarea>
          <v-select
            v-model="data.companyId"
            :items="selectOptions.lensCompanies"
            item-text="name"
            item-value="id"
            outlined
            label="Company"
          >
            <!-- <template v-slot:item="{ item }">
              {{ metaOptions.lensCompanies[item.id].name }}
            </template> -->
          </v-select>
          <div class="d-flex flex-row">
            <v-text-field
              label="Website"
              v-model="data.url"
              outlined
              class="mr-4"
            ></v-text-field>

            <v-btn
              text
              small
              @click="showIframe = !showIframe"
              v-if="data.url"
              color="primary"
              >open
              <v-icon small color="primary" class="mx-2"
                >mdi-view-split-vertical</v-icon
              ></v-btn
            >
          </div>

          <v-card flat class="cardColor my-4" outlined
            ><v-card-title class="headerBkg">Material Options</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="body-1 grayText">
              <rgp-material-picker
                v-if="metaOptions"
                :materials="metaOptions.materials"
                :materialCompanies="metaOptions.companies"
                :materialsByCompany="metaOptions.materialsByCompany"
                :external="data.materials"
                @change="data.materials = $event"
              ></rgp-material-picker>

              <div class="d-flex flex-row mt-2">
                <v-text-field
                  label="Notes regarding materials"
                  v-model="data.materialText"
                  outlined
                  class="mr-4"
                  clearable
                ></v-text-field>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="cardColor my-4" flat
            ><v-card-title class="headerBkg">Parameter Options</v-card-title>

            <v-card-text class="py-4">
              <draggable
                v-model="data.parameters"
                group="people"
                @start="drag = true"
                @end="drag = false"
              >
                <div
                  v-for="(row, i) in data.parameters"
                  :key="i"
                  class="d-flex flex-row align-center"
                >
                  <v-icon style="cursor: grab" class="mx-1" color="#a8a8a8"
                    >mdi-reorder-horizontal</v-icon
                  >
                  <v-textarea
                    v-model="data.parameters[i].text"
                    rows="2"
                    class="pb-2"
                    outlined
                    dense
                    :label="row.label"
                    clearable
                    hide-details
                  ></v-textarea>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        small
                        @click="data.parameters[i].text = 'Made-to-order'"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        ><v-icon small>mdi-chevron-left</v-icon>MTO</v-btn
                      >
                    </template>
                    <span>Populate with "Made-to-order"</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        @click="deleteParam(i)"
                        v-bind="attrs"
                        v-on="on"
                        ><v-icon small color="red"
                          >mdi-trash-can-outline</v-icon
                        ></v-btn
                      >
                    </template>
                    <span>Remove this field</span>
                  </v-tooltip>
                  <!-- <v-divider vertical class="mx-2"></v-divider> -->
                </div>
              </draggable>
              <v-btn text @click="addParamDialog = true" color="primary"
                ><v-icon color="green" class="mr-2 mt-3"
                  >mdi-plus-circle-outline</v-icon
                >Add Field</v-btn
              >
            </v-card-text>

            <v-textarea
              rows="2"
              label="Parameters notes"
              v-model="data.parameter_notes"
              outlined
              class="mx-4 py-3"
              clearable
            ></v-textarea>
          </v-card>

          <v-card flat class="cardColor my-4" outlined
            ><v-card-title class="headerBkg"
              >Lens Type and Tags (Check all that apply)</v-card-title
            >

            <v-card-text>
              <!-- <div class="overline">Tags</div> -->

              <v-btn-toggle
                v-model="data.lensType"
                rounded
                class="my-2"
                active-class="activeToggle"
              >
                <v-btn small rounded depressed value="corneal"
                  >Corneal Lens</v-btn
                >
                <v-btn small rounded depressed value="scleral"
                  >Scleral Lens</v-btn
                >
                <v-btn small rounded depressed value="ortho-k"
                  >Ortho-k / CRT Lens</v-btn
                >
              </v-btn-toggle>
              <v-divider></v-divider>
              <div class="pt-4" v-if="metaOptions && metaOptions.tagGroups">
                <!-- {{ data.tags }} -->
                <rgp-tag-selector
                  :rgpOptions="metaOptions"
                  :allowedTags="metaOptions.tagsForType[data.lensType]"
                  :activeTags="data.tags"
                  @tags="data.tags = $event"
                ></rgp-tag-selector>
              </div>
            </v-card-text>
          </v-card>

          <!-- {{ tagUpdates }} -->

          <v-card flat class="cardColor my-4" outlined
            ><v-card-title class="headerBkg">More Info</v-card-title>

            <v-card-text class="pt-4">
              <md-textarea v-model="data.otherInfo"></md-textarea>
            </v-card-text>
          </v-card>
        </v-form>

        <v-card flat class="cardColor my-4" outlined
          ><v-card-title class="headerBkg">Media</v-card-title>

          <v-card-text>
            <media-uploader
              v-if="!newItem && data && data.id"
              :fileNameRoot="data.slug"
              :previousFiles="data.media"
              :limit="10"
              :title="null"
              dir="rgp_media"
              :productId="data.id"
              accept=".pdf,.jpg,.jpeg,.png"
              @fileList="data.media = $event"
            ></media-uploader>
            <div v-else class="font-weight-bold">
              For images & PDFs: Save this lens, then reopen this page.
            </div>
          </v-card-text>
        </v-card>

        <v-divider class="my-2"></v-divider>
      </div>

      <div v-if="iframeSrc && showIframe" :class="panelCSS">
        <div class="d-flex flex-row justify-space-between">
          <v-btn
            text
            x-small
            color="primary"
            :href="data.url"
            v-if="data.url"
            target="_blank"
            >Open in new tab
            <v-icon color="primary" small>mdi-open-in-new</v-icon></v-btn
          >
          <v-btn x-small color="primary" text @click="showIframe = false"
            >Close</v-btn
          >
        </div>
        <iframe
          :src="iframeSrc"
          class="width100p"
          style="height: 90vh"
        ></iframe>
      </div>
    </div>
    <!-- <v-card class="my-8">{{ data }}</v-card> -->
    <v-alert v-if="error">{{ error }}</v-alert>
    <v-snackbar v-model="updatedSnackbar" :timeout="2000" top color="success">
      {{ pageTitle }} Updated</v-snackbar
    >
    <v-snackbar v-model="deletedSnackbar" :timeout="2000" top color="alert">
      {{ pageTitle }} Deleted</v-snackbar
    >

    <!-- . . . add param dialog -->
    <v-dialog v-model="addParamDialog" max-width="300">
      <v-card>
        <v-card-title class="d-flex flex-row"
          >Choose/Add Field

          <v-spacer></v-spacer>
          <v-btn icon @click="addParamDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="d-flex flex-column mt-3">
          <v-btn
            depressed
            v-for="field in unusedParameters"
            :key="field"
            @click="addParam(field)"
            outlined
            rounded
            color="primary"
            class="my-1"
          >
            {{ field }}
          </v-btn>
          <div class="d-flex flex-row align-center mt-4">
            <v-text-field
              v-model="paramToAdd"
              dense
              outlined
              label="Or add custom field"
              class="mr-2"
              hide-details="auto"
            ></v-text-field>
            <v-btn
              color="primary"
              @click="addParam(paramToAdd)"
              :disabled="!paramToAdd"
              >Add</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- . . . / add param dialog -->

    <!-- {{ data }} -->
    <!-- <p>{{ metaOptions }}</p> -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import UserMixin from "@/assets/js/UserMixin";
import ApiOptionsMixin from "@/assets/js/ApiOptionsMixin";
import Slugify from "slugify";
import MdTextarea from "@/components/adminStuff/MdTextarea";
import RgpTagSelector from "@/components/gpStuff/RgpTagSelector";
import RgpMaterialPicker from "@/components/adminStuff/RGPsAdmin/RgpMaterialPicker";
import RgpOptionsMixin from "@/assets/js/rgps/RgpOptionsMixin.js";
import draggable from "vuedraggable";

export default {
  name: "EditRgpLens",
  components: {
    // ImageBrowserUploader: () =>
    //   import("@/components/adminStuff/ImageBrowserUploader"),
    MediaUploader: () => import("@/components/adminStuff/MediaUploader"),
    MdTextarea,
    RgpTagSelector,
    RgpMaterialPicker,
    draggable,
  },
  mixins: [UserMixin, ApiOptionsMixin, RgpOptionsMixin],
  props: {
    slug: null,
  },
  data: function () {
    return {
      //metaOptions in mixin

      loading: false,
      pageTitle: "Add Lens",
      // apiPath: "/rgps/addLens389",
      // newImageFiles: [], // t
      updatedSnackbar: false,
      deletedSnackbar: false,
      // meta: null,
      iframeSrc: null,
      materialType: null, // 'any', 'companies' or, 'materials'
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length >= 4) || "Name must be at least 4 characters",
      ],
      notNull: [(v) => !!v || "Category is required"],
      additionalFields: [],
      defaultData: {
        id: 0,
        name: "",
        slug: "",
        aliases: null,
        companyId: null,
        anyMaterial: 0,
        materialText: null,
        url: null,
        parameters: [
          {
            label: "Base Curves",
            text: null,
          },
          {
            label: "Diameters",
            text: null,
          },
          {
            label: "Sphere Powers",
            text: null,
          },
          {
            label: "Add Powers",
            text: null,
          },
        ],
        parameter_notes: null,
        materials: { any: 0, companies: null, materials: null },
        materialCompanies: [],
        materialAny: 0,
        otherInfo: null,
        lensType: "corneal",
        tags: [],
        media: [],
        discontinued: 0,
        display: 1,
        added: null,
        updated: null,
      },

      data: null,
      valid: false,
      slugManuallyUpdated: false,
      error: null,
      showIframe: false,
      // activeTags: [0, 1, 3, 6, 8, 9, 10],
      lenses: null,
      addParamDialog: false,
      // paramInput: null,
      paramToAdd: null,
      originalTags: [],
      originalMaterials: { companies: [], materials: [] },
      // currentParamFields: [],
      desiredParameters: [
        // strings must match possibleParameters
        "Base Curves",
        "Diameters",
        "Sphere Powers",
        "Add Powers",
      ],
      possibleParameters: [
        "Base Curves",
        "Diameters",
        "Sphere Powers",
        "Toric Powers",
        "Add Powers",
        "Optic Zones",
        "Add Zone",
        "Seg Heights",
      ],
    };
  },
  methods: {
    getData() {
      this.loading = true;
      if (!this.slug) return; // show error?
      this.error = null;
      ApiServices.rgpLensDetails(this.slug, true) // admin = true
        .then((response) => {
          this.populateContentFromAPI(response.data?.details);
          // this.meta = response.data?.meta;
          this.pageTitle = this.data.name;
          this.error = null;
        })
        .catch((error) => {
          console.log("error", error);
          if (error) this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exitPage() {
      this.$router.push({ path: "/boss/rgp-lenses" });
    },
    doSave() {
      this.loading = true;
      let data = { ...this.data };
      data.tags = this.tagUpdates;
      data.anyMaterial = data.materials?.anyMaterial;
      data.materials = this.materialUpdates;
      // data.lensType = this.lensType;

      this.error = null;
      data.auth = this.auth_credentials;
      // console.log("api data", data);
      // return;
      // console.log("apiPath", this.metaOptions.adminApis.addLens);
      let apiPath = this.metaOptions?.adminAPIs?.addLens; // from ApiOptionsMixin
      if (!apiPath) {
        console.log("no API path");
        return;
      }
      ApiServices.genericUpdateItem("/rgps/" + apiPath, data)
        .then((response) => {
          if (response.data.error) {
            this.error = response.data.error;
          } else if (response.data.success) {
            this.error = null;
            this.updatedSnackbar = true;
            this.exitPage();
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
        })
        .finally(() => {});
    },

    resetAll() {
      this.data = { ...this.defaultData };
      // this.syncParamKeys();
      this.pageTitle = "Add RGP Company";
    },
    populateContentFromAPI(data) {
      if (data?.display) data.display = parseInt(data.display);
      if (data?.discontinued) data.discontinued = parseInt(data.discontinued);
      this.iframeSrc = data.url;
      if (!data.parameters) data.parameters = this.defaultData.parameters;
      // data.newMedia = [];
      this.data = data;
      this.setMaterials(data.materials);
      if (data.tags) this.originalTags = [...data.tags];
      if (data.materials)
        this.originalMaterials = JSON.parse(JSON.stringify(data.materials));
      // if (!data.materials) this.materialData = this.materialDefaults; // todo - populate this from api
      // this.syncParamKeys();
    },
    // takes the materials data from the API
    // will have a key for "any", "material", and "companies"
    setMaterials(materials) {
      // console.log(materials);
      if (materials?.any == 1) {
        this.materialType = "any";
      } else if (materials?.companies) {
        this.materialType = "companies";
      } else if (materials?.materials) {
        this.materialType = "materials";
      }
    },

    nameChange() {
      if (this.data.name != "") this.pageTitle = this.data.name;
      if (!this.slugManuallyUpdated && this.newItem)
        this.updateSlug(this.data.name);
    },
    updateSlug(val) {
      if (val && this.data) {
        val = val.replace(/[()]/g, " ");
        this.data.slug = Slugify(val.toLowerCase());
      }
    },

    editSlugPrompt() {
      if (!this.data?.slug) return;
      let txt = "Choose a new vanity URL for item.";
      if (!this.newItem)
        txt +=
          "\n\nPlease be aware that changing the vanity URL will break any existing links to this item's listing! ";
      let newSlug = prompt(txt, this.data.slug);
      if (newSlug && newSlug != this.data.slug) {
        this.updateSlug(newSlug);
        this.slugManuallyUpdated = true;
      }
    },

    addParam(paramToAdd) {
      if (!paramToAdd) return;
      this.data.parameters.push({ label: paramToAdd, value: null });
      this.addParamDialog = false;
      this.paramToAdd = null;
      // this.syncParamKeys();
    },

    deleteParam(i) {
      let thing = this.data.parameters[i];
      let doIt = true; //
      if (thing?.text && thing.text != "") {
        doIt = confirm(
          "Are you sure you want to delete this parameter? It's value will be erased.."
        );
      }
      if (doIt) this.data.parameters.splice(i, 1);
    },

    // takes two arrays, finds items to add to or delete from the db
    compareArrays(current, original) {
      if (!current) current = [];
      if (!original) original = [];
      let add = current.filter((x) => !original.includes(x));
      let kill = original.filter((x) => !current.includes(x));
      return { add: add, delete: kill };
    },
  },
  computed: {
    headerClass: function () {
      return this.$vuetify.breakpoint.smAndUp ? "bigHead" : "smallHead";
    },

    newItem: function () {
      return this.slug == "new";
    },
    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    panelCSS: function () {
      if (this.showIframe && this.data.url && !this.isMobile)
        return "halfScreen";
      return "width100p";
    },
    selectOptions: function () {
      let rtn = {
        lensCompanies: [],
        // materialCompanies: [],
        // materials: [],
      };
      let m = this.metaOptions;
      if (m?.companies)
        rtn.lensCompanies = this.metaOptions.companiesOrder.map((id) => {
          return m.companies[id];
        });

      return rtn;
    },

    currentParamFields: function () {
      let labels = [];
      let params = this.data?.parameters;
      if (!params) return labels;
      params.forEach((row) => {
        labels.push(row.label);
      });

      return labels;
    },
    unusedParameters: function () {
      let rtn = [];
      let used = this.currentParamFields;
      this.possibleParameters.forEach((param) => {
        if (!used.includes(param)) rtn.push(param);
      });
      return rtn;
    },
    tagUpdates: function () {
      let original = this.originalTags;
      let current = this.data.tags;
      return this.compareArrays(current, original);
    },

    materialUpdates: function () {
      let origObj = this.originalMaterials;
      let curObj = this.data.materials;
      if (!curObj) return origObj;
      let origMats = origObj.materials;
      let curMats = curObj.materials;
      let origComps = origObj.companies;
      let curComps = curObj.companies;
      let matChange = this.compareArrays(curMats, origMats);
      let compChange = this.compareArrays(curComps, origComps);
      return { materials: matChange, companies: compChange };
    },
    rgpOptions: function () {
      return this.metaOptions; // just so I can use the functions in the rgpOptionsMixin ..
    },
  },
  watch: {},

  mounted() {
    // the following references userMixin & ApiOptionsMixin
    this.getItemOptions("/rgps/options?", "admin=1&" + this.auth_paramstring);
    if (!this.newItem) {
      this.getData();
    } else {
      this.resetAll();
    }
  },
  metaInfo() {
    return {
      title: "EyeDock Admin - RGPs " + this.pageTitle,
    };
  },
};
</script>

<style scoped>
.headerBkg {
  background-color: #e0f2ff;
  /* border-bottom: 1px solid #bfd5e5; */
  /* margin-bottom: -1px; */
}
.cardColor {
  background-color: #f9fdff;
  border: 1px solid #cfebff;
}
.halfScreen {
  width: 45vw;
  height: 90vh;
  overflow-y: scroll;
}

.formPanel {
  max-width: 1200px;
  border: 1px solid gray;
  margin: 1em;
  padding: 0 1em;
}

.v-btn--active::before {
  content: none;
}
</style>
